import axiosInstance from "./api";
import TokenService from "./token.service";
import router from "../router";

const setup = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token; 
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
  // ...existing code...
      if (originalConfig.url !== "/auth/signin" && err.response) {
  // ...existing code...
        // Access Token was expired or forbidden
        if ((err.response.status === 401 || err.response.status === 403) && !originalConfig._retry) {
            originalConfig._retry = true;
            store.dispatch("auth/logout");
            router.push("/home").catch(() =>{});
        }
      }
      return Promise.reject(err);
    }
  );
};
export default setup;